import { classifySignableSigners } from './helper';
import { Event, Properties } from '../../enums/Analytics';
import { SignableSchema } from '../../definitions/schemas';
import Analytics, { EventProperty } from '../../tools/Analytics';

interface TrackingPropertiesParams {
  [key: string]: string | number | boolean | undefined;
}

export const trackSignableEvent = (
  event: Event,
  referrer: string,
  signable?: SignableSchema,
  customParams?: TrackingPropertiesParams
) => {
  let trackingProperties: EventProperty = {
    [Properties.ENTERED_FROM]: referrer,
  };

  if (signable) {
    const { signers = [] } = signable;
    const [signed, , assigned] = classifySignableSigners(signers);
    const unassigned = (signers.length || 0) - (assigned.length || 0);

    trackingProperties = {
      ...trackingProperties,
      [Properties.FROM_TEMPLATE]: !!signable.signableTemplateId,
      [Properties.NUMBER_ASSIGNED_SIGNERS]: assigned.length,
      [Properties.NUMBER_SIGNED]: signed.length,
      [Properties.NUMBER_UNASSIGNED_SIGNERS]: unassigned,
      [Properties.PROVIDER]: signable.provider,
      [Properties.SIGNABLE_CONNECTION_STATUS]: signable.syncStatus,
      [Properties.SIGNABLE_STATUS]: signable.status,
    };
  }

  if (customParams) {
    trackingProperties = {
      ...trackingProperties,
      ...customParams,
    };
  }

  Analytics.track(event, trackingProperties);
};
